import { GroupForm } from "./GroupForm";

export function GroupCreatePage() {
  return <GroupForm mode="create" />;
}
